module.exports = __webpack_public_path__ + "static/media/meeting-tool-profile.848b99e3.svg";